import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { PortalApiService } from '../../../../_services/portal-api.service';
import { RunTicket } from '../../../../_models/field';
import { DatePipe } from '@angular/common';
import * as _ from 'lodash';

@Component({
  selector: 'app-move-run-ticket-date',
  templateUrl: './move-run-ticket-date.component.html',
  styleUrls: ['./move-run-ticket-date.component.css'],
  providers: [DatePipe]
})
export class MoveRunTicketDateComponent implements OnInit, OnDestroy {
  @Input() ticketToMove: RunTicket;
  @Input() entryDate: string;
  @Input() actionStrip: any;
  @Output() ticketMoved: EventEmitter<RunTicket> = new EventEmitter();

  moveBackward: boolean = true;
  moveForward: boolean = true;
  isSubmitting: boolean = false;
  errorMessage: string;
  formattedDayBefore: string;
  formattedDayAfter: string;

  constructor(
    private apiService: PortalApiService,
    private datePipe: DatePipe
  ) {
  }

  ngOnInit() {}

  ngOnDestroy() {

  }

  openDialog(dialog) {
    this.errorMessage = null;
    this.isSubmitting = false;
    this.setDateRange();
   
    dialog.open();
  }

  setDateRange() {
    const dateString = this.entryDate + 'T00:00:00';
    const newEntryDate = new Date(dateString);

    const oneDay = 24 * 60 * 60 * 1000;
    const dayBefore = new Date(newEntryDate.getTime() - oneDay);
    const dayAfter = new Date(newEntryDate.getTime() + oneDay);

    this.formattedDayBefore = this.datePipe.transform(dayBefore, 'yyyy-MM-dd');
    this.formattedDayAfter = this.datePipe.transform(dayAfter, 'yyyy-MM-dd');
  }

  /*confirmMoveBackward(backward: boolean) {
    this.errorMessage = null;
    this.isSubmitting = true;

    let selectedDate: string;

    if (backward) {
      selectedDate = this.formattedDayBefore;
    } else {
      selectedDate = this.formattedDayAfter;
    }

    this.apiService.updateRunTicketDate(this.ticketToMove.tankID, this.ticketToMove.ticket, this.entryDate, selectedDate).subscribe({
      next: () => {
        this.isSubmitting = false;
        let movedTicket: RunTicket = _.cloneDeep(this.ticketToMove);
        this.ticketMoved.emit(movedTicket);
        this.modalService.dismissAll();
      },
      error: err => {
        console.log(err);
        this.errorMessage = 'There is no data sheet available for this date. Please move this run ticket to an available data sheet.';
        this.isSubmitting = false;
      }
    })
  }*/

  confirmMovePrevious(event, previous: boolean) {
    this.errorMessage = null;
    this.isSubmitting = true;
    const ticketToMove = this.actionStrip.data;

    let selectedDate: string;

    if (previous) {
      selectedDate = this.formattedDayBefore;
    } else {
      selectedDate = this.formattedDayAfter;
    }

    this.apiService.updateRunTicketDate(ticketToMove.tankID, this.entryDate, selectedDate, ticketToMove.ticket).subscribe({
      next: () => {
        this.isSubmitting = false;
        let movedTicket: RunTicket = _.cloneDeep(ticketToMove);
        this.ticketMoved.emit(movedTicket);
        event.dialog.close();
      },
      error: err => {
        console.log(err);
        this.errorMessage = 'Sorry, there is no data sheet available. Please select a different date.';
        this.isSubmitting = false;
      }
    })
  }
}
